import { HISTORY_BASE_URL } from '../utils/ApiUrls';



class DetailedHistoryService {

  // Get complete evolution history for a specific user
  async getUserEvolutionHistory(userId, accessToken) {
    try {
      const response = await fetch(`${HISTORY_BASE_URL}/user/${userId}/evolution/`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          status: response.status,
          error: data.detail || 'Error fetching user evolution history',
          errorData: data,
        };
      }

      return {
        success: true,
        status: response.status,
        data,
      };
    } catch (error) {
      return {
        success: false,
        status: 0,
        error: error.message || 'Network error occurred',
        errorData: null,
      };
    }
  }

  // Get complete evolution history for a specific risk
  async getRiskEvolutionHistory(riskId, accessToken) {
    try {
      const response = await fetch(`${HISTORY_BASE_URL}/risk/${riskId}/evolution/`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          status: response.status,
          error: data.detail || 'Error fetching risk evolution history',
          errorData: data,
        };
      }

      return {
        success: true,
        status: response.status,
        data,
      };
    } catch (error) {
      return {
        success: false,
        status: 0,
        error: error.message || 'Network error occurred',
        errorData: null,
      };
    }
  }

  // // Get complete evolution history for a specific activity
  // async getActivityEvolutionHistory(activityId, accessToken) {
  //   try {
  //     const response = await fetch(`${HISTORY_BASE_URL}/activity/${activityId}/evolution/`, {
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Authorization': `Bearer ${accessToken}`,
  //       },
  //     });

  //     const data = await response.json();

  //     if (!response.ok) {
  //       return {
  //         success: false,
  //         status: response.status,
  //         error: data.detail || 'Error fetching activity evolution history',
  //         errorData: data,
  //       };
  //     }

  //     return {
  //       success: true,
  //       status: response.status,
  //       data,
  //     };
  //   } catch (error) {
  //     return {
  //       success: false,
  //       status: 0,
  //       error: error.message || 'Network error occurred',
  //       errorData: null,
  //     };
  //   }
  // }


  // Get complete evolution history for a specific activity (combined Activity + ActivityRisk history)
  async getActivityEvolutionHistory(activityId, accessToken, pagination_data = {}) {
    try {
      const queryParams = new URLSearchParams();
      if (pagination_data.page) {
        queryParams.append('page', pagination_data.page);
      }
      if (pagination_data.page_size) {
        queryParams.append('page_size', pagination_data.page_size);
      }
  
      const queryString = queryParams.toString();
      const url = `${HISTORY_BASE_URL}/activity/${activityId}/evolution/${queryString ? `?${queryString}` : ''}`;
  
      const response = await fetch(url, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
        },
      });
  
      const data = await response.json();
  
      if (!response.ok) {
        return {
          success: false,
          status: response.status,
          error: data.detail || 'Error fetching activity evolution history',
          errorData: data,
        };
      }
  
      return {
        success: true,
        status: response.status,
        data,
      };
    } catch (error) {
      return {
        success: false,
        status: 0,
        error: error.message || 'Network error occurred',
        errorData: null,
      };
    }
  }

  
  // Get complete evolution history for a specific process
  async getProcessEvolutionHistory(processId, accessToken) {
    try {
      const response = await fetch(`${HISTORY_BASE_URL}/process/${processId}/evolution/`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          status: response.status,
          error: data.detail || 'Error fetching process evolution history',
          errorData: data,
        };
      }

      return {
        success: true,
        status: response.status,
        data,
      };
    } catch (error) {
      return {
        success: false,
        status: 0,
        error: error.message || 'Network error occurred',
        errorData: null,
      };
    }
  }

  // Get complete evolution history for a specific process task
  async getProcessTaskEvolutionHistory(processTaskId, accessToken) {
    try {
      const response = await fetch(`${HISTORY_BASE_URL}/process-task/${processTaskId}/evolution/`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          status: response.status,
          error: data.detail || 'Error fetching process task evolution history',
          errorData: data,
        };
      }

      return {
        success: true,
        status: response.status,
        data,
      };
    } catch (error) {
      return {
        success: false,
        status: 0,
        error: error.message || 'Network error occurred',
        errorData: null,
      };
    }
  }
    
}

const detailedHistoryService = new DetailedHistoryService();
export default detailedHistoryService;
